import VerticalTabs from './views/VerticalTabs.c';
export default VerticalTabs;
